import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { formDataGenerator, getRouting } from '../../../../../utils/common';
import './style.scss';
import { getMarketReviewList } from '../actions';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import PaginationComponent from '../../../general/PaginationComponent';
import SubscribeKnowledgeStack from '../SubscribeKnowledgeStack';

const MarketReview = (props) => {

  const { getMarketReviewList, MarketReviewList, location: { pathname }, } = props;

  const [searchValue, setSearchValue] = useState("");
  const [marketReview, setMarketReview] = useState("");
  const [limit, setLimit] = useState(8);
  const [offset, setOffset] = useState(0);
  const [totalRecords, setTotalRecords] = useState(0);
  const [activePage, setActivePage] = useState(1);
  const [data, setData] = useState([]);
  const [metaData, setMetaData] = useState();

  const getPaginatedData = (page) => {
    loadData(page);
  };

  const loadData = (page) => {
    const offsetValue = limit * page;
    let params = {
      search: searchValue ? searchValue : "",
      limit: limit,
      offset: limit * (page - 1),
    };
    getMarketReviewList(formDataGenerator(params));
    let unit = window.innerHeight / 100;
    window.scrollTo({ top: 40 * unit });
  };

  useEffect(() => {
    let params = {
      search: searchValue ? searchValue : "",
      limit: limit,
      offset: offset,
    };
    getMarketReviewList(formDataGenerator(params));
  }, [searchValue]);

  useEffect(() => {
    if (MarketReviewList && MarketReviewList.marketReviewData &&
      MarketReviewList.marketReviewData.items) {
      setMarketReview(MarketReviewList.marketReviewData.items);
      setTotalRecords(MarketReviewList.marketReviewData.count ? MarketReviewList.marketReviewData.count : 0);
    }

    // if (MarketReviewList && MarketReviewList.marketReviewData &&
    //   MarketReviewList.marketReviewData.count) {
    //   setTotalRecords(MarketReviewList.marketReviewData.count);
    // }

    if (MarketReviewList && MarketReviewList.marketReviewData &&
      MarketReviewList.marketReviewData.meta) {
      setMetaData(MarketReviewList.marketReviewData.meta);
    }

  }, [MarketReviewList]);

  const handleInputsearch = (e) => {
    setSearchValue(e.target.value);
    setActivePage(1);
  }
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [])
  const typedata ="Market Review";
  const articledata = "";

  return (
    <div className='wrapper'>
      {
        metaData ? (
          <Helmet>
            <title>{metaData && metaData.title ? metaData.title : ""}</title>
            <meta name="description"
              content={
                metaData && metaData.description ? metaData.description : ""
              }
            />
            <meta name="keywords"
              content={
                metaData && metaData.keywords ? metaData.keywords : ""
              }
            />
            <meta property="og:title"
              content={
                metaData && metaData.og_title ? metaData.og_title : ""
              }
            />
            <meta property="og:description"
              content={
                metaData && metaData.og_description ? metaData.og_description : ""
              }
            />
            <meta property="og:image"
              content={
                metaData && metaData.og_image ? metaData.og_image : ""
              }
            />
            <meta property="og:url"
              content={
                metaData && metaData.og_url ? metaData.og_url : ""
              }
            />
          </Helmet>
        ) : ("")
      }
      <section className="aboutHead">
        <div className="container">
          <div className="d-flex dropdowncls">
            <div className="dropdown me-auto">
              <div>
                <h1>
                  <span>Market </span>Review
                </h1>
              </div>
            </div>
            <nav
              aria-label="breadcrumb"
              className="align-self-center breadCrumbCust d-md-inlin"
            >
              <ol className="breadcrumb mb-0">
                <li className="breadcrumb-item">
                  <Link to={getRouting(`/`)}>Home</Link>
                </li>
                <li className="breadcrumb-item">
                  <Link to={getRouting(`/knowledge-stack`)}>Knowledge Stack</Link>
                </li>
                <li
                  className="breadcrumb-item active breadcolor"
                  aria-current="page"
                >
                  Market Review
                </li>
              </ol>
            </nav>
          </div>
        </div>
      </section>
      <section>
        <div className='container reviews'>
          <p className='my-4'>Global and domestic economy / market outlook</p>
          <div className='row mt-3'>
            <div className={searchValue ? "col-md-5 d-flex" : "col-md-4 d-flex"}>
              <div className="input-group mb-3 ipgroup">
                <span className="input-group-text serchcolor" id="inputGroup-sizing-default">
                  <img src="/images/New/grey-search.svg" alt="search" />
                </span>
                <input
                  type="text"
                  className="form-control searchb ps-0 py-2"
                  aria-label="Sizing example input"
                  aria-describedby="inputGroup-sizing-default"
                  placeholder="Search..."
                  onChange={handleInputsearch}
                  value={searchValue}
                />
              </div>
              {searchValue ? (
                <button
                  className="btn resetbtn"
                  onClick={handleInputsearch}
                >
                  Reset
                </button>
              ) : ""
              }
            </div>
          </div>

          <div className="row mt-4">
            {
              marketReview && marketReview.length > 0 ?
              (marketReview.map((item, index) => (
                <div className="col-md-3 mb-3">
                  <div className='card'>
                    <a href={`/knowledge-stack/macro-insights/market-review/${item.linkUrl}`}>
                      <img
                        src={item.imageURL &&
                          item.imageURL.url ? item.imageURL.url : ""}
                        className="card-img-top w-100"
                        alt={item.imageURL &&
                          item.imageURL.alt ? item.imageURL.alt : ""}
                      />
                    </a>
                    <div className="card-body px-0">
                      <a href={`/knowledge-stack/macro-insights/market-review/${item.linkUrl}`}>
                        <h5 className="card-title">
                          {item.title ? item.title : ""}
                        </h5>
                      </a>

                      <p className="card-text">
                        {item.description ? item.description : ""}
                      </p>
                      <div className='timestamp'>
                        <p>{item.publishedDate ? item.publishedDate : ""}</p>
                        <p>{item.time ? item.time : ""}</p>
                      </div>
                    </div>
                  </div>
                </div>
              )))
              : (
                <div className='nodata'>
                  <p>No content found.</p>
                </div>
              )
            }
          </div>

          {
            totalRecords > 8 && (
              <div className="row">
                <div className="col-md-12">
                  <div className="paginate d-flex justify-content-center">
                    <PaginationComponent
                      totalRecords={totalRecords}
                      activePage={activePage}
                      setActivePage={setActivePage}
                      data={data}
                      limit={limit}
                      getPaginatedData={getPaginatedData}
                      itemsCountPerPage={limit}
                    />
                  </div>
                </div>
              </div>
            )
          }
          <SubscribeKnowledgeStack type={typedata} article={articledata}/>
        </div>
      </section>
    </div>
  )
}

const mapStateToProps = (state) => ({
  MarketReviewList: state.KnowledgeStack,
});

const mapDispatchToProps = (dispatch) => ({
  getMarketReviewList: bindActionCreators(getMarketReviewList, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(MarketReview);
